var BandwidthOptions;
(function (BandwidthOptions) {
    BandwidthOptions["OPTION1"] = "62500";
    BandwidthOptions["OPTION2"] = "125000";
    BandwidthOptions["OPTION3"] = "250000";
    BandwidthOptions["OPTION4"] = "500000";
})(BandwidthOptions || (BandwidthOptions = {}));
export default BandwidthOptions;
